import styled, { css } from 'styled-components';
import { getTypographyStyles, SEM_TYPOGRAPHY_ACTION_XS_LABEL, SYS_BORDER_RADIUS_MAX, SYS_SIZE_FIXED_900, SYS_SPACE_FIXED_100, getMargins, SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_1200, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_400, SEM_TYPOGRAPHY_ACTION_MD_LABEL, SEM_TYPOGRAPHY_ACTION_SM_LABEL } from '@oneaudi/unified-web-alpha-common';
import { ProgressIndicator } from '../progress-indicator/index.js';
import { Icon } from '../icon/index.js';
export const StyledIcon = styled(Icon) `
  // TODO: missing token
  flex-shrink: 0;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color;
`;
export const StyledButton = styled.button `
  ${(props) => props.isLoading &&
    css `
      position: relative;
    `}
  margin: ${(props) => getMargins(props.margin)};
  border: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  border-radius: ${SYS_BORDER_RADIUS_MAX};

  ${(props) => {
    if (props.disabled && !props.isLoading) {
        return css `
        cursor: not-allowed;
      `;
    }
    if (props.isLoading) {
        return css `
        cursor: progress;
      `;
    }
    return css `
      cursor: pointer;
    `;
}}

  svg {
    flex-shrink: 0;
  }

  ${(props) => props.as === 'a'
    ? css `
          display: inline-flex;
          box-sizing: border-box;
          text-align: center;
        `
    : css `
          display: flex;
          border: 0;
        `}

  ${(props) => props.size === 'md'
    ? css `
          ${getTypographyStyles(SEM_TYPOGRAPHY_ACTION_MD_LABEL)}
          padding: ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_400};
          min-height: ${SYS_SIZE_FIXED_1400};
        `
    : props.size === 'sm'
        ? css `
            ${getTypographyStyles(SEM_TYPOGRAPHY_ACTION_SM_LABEL)}
            padding: ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_300};
            min-height: ${SYS_SIZE_FIXED_1200};
          `
        : css `
            ${getTypographyStyles(SEM_TYPOGRAPHY_ACTION_XS_LABEL)}
            padding: ${SYS_SPACE_FIXED_100} ${SYS_SPACE_FIXED_200};
            min-height: ${SYS_SIZE_FIXED_900};
          `}


  ${(props) => props.isFullWidth &&
    css `
      width: 100%;
    `}

    ${({ $selected, theme, variant, isLoading, as }) => {
    const state = $selected ? 'selected' : 'default';
    if (variant === 'primary') {
        const primary = theme.sem.color.action.primary;
        return css `
        background: ${primary.surface.fill[state]};
        color: ${primary.foreground.text[state]};
        box-shadow: inset 0 0 0 1px ${primary.surface.stroke[state]};
        transition-property: color, background, box-shadow;

        ${StyledIcon} {
          color: ${primary.foreground.icon[state]};
        }

        ${!isLoading &&
            css `
          &:hover {
            background: ${primary.surface.fill.hover};
            color: ${primary.foreground.text.hover};
            box-shadow: inset 0 0 0 1px ${primary.surface.stroke.hover};

            ${StyledIcon} {
              color: ${primary.foreground.icon.hover};
            }
          }

          &:active {
            background: ${primary.surface.fill.pressed};
            color: ${primary.foreground.text.pressed};
            box-shadow: inset 0 0 0 1px ${primary.surface.stroke.pressed};

            ${StyledIcon} {
              color: ${primary.foreground.icon.pressed};
            }
          }
        `}

        ${as === 'button' &&
            !isLoading &&
            css `
          &:disabled {
            background: ${primary.surface.fill.disabled};
            color: ${primary.foreground.text.disabled};
            box-shadow: inset 0 0 0 1px ${primary.surface.stroke.disabled};

            ${StyledIcon} {
              color: ${primary.foreground.icon.disabled};
            }
          }
        `}
      `;
    }
    if (variant === 'secondary') {
        const secondary = theme.sem.color.action.secondary;
        return css `
        background-color: ${secondary.surface.fill[state]};
        color: ${secondary.foreground.text[state]};
        box-shadow: inset 0 0 0 1px ${secondary.surface.stroke[state]};
        transition-property: color, box-shadow, background-color;

        ${StyledIcon} {
          color: ${secondary.foreground.icon[state]};
        }

        ${!isLoading &&
            css `
          &:hover {
            background-color: ${secondary.surface.fill.hover};
            color: ${secondary.foreground.text.hover};
            box-shadow: inset 0 0 0 1px ${secondary.surface.stroke.hover};

            ${StyledIcon} {
              color: ${secondary.foreground.icon.hover};
            }
          }

          &:active {
            background-color: ${secondary.surface.fill.pressed};
            color: ${secondary.foreground.text.pressed};
            box-shadow: inset 0 0 0 1px ${secondary.surface.stroke.pressed};

            ${StyledIcon} {
              color: ${secondary.foreground.icon.pressed};
            }
          }
        `}

        ${as === 'button' &&
            !isLoading &&
            css `
          &:disabled {
            background-color: ${secondary.surface.fill.disabled};
            color: ${secondary.foreground.text.disabled};
            box-shadow: inset 0 0 0 1px ${secondary.surface.stroke.disabled};

            ${StyledIcon} {
              color: ${secondary.foreground.icon.disabled};
            }
          }
        `}
      `;
    }
    const tertiary = theme.sem.color.action.tertiary;
    return css `
      background-color: ${tertiary.surface.fill[state]};
      color: ${tertiary.foreground.text[state]};
      box-shadow: inset 0 0 0 1px ${tertiary.surface.stroke[state]};
      transition-property: color, box-shadow, background-color;

      ${StyledIcon} {
        color: ${tertiary.foreground.icon[state]};
      }

      ${!isLoading &&
        css `
        &:hover {
          background-color: ${tertiary.surface.fill.hover};
          color: ${tertiary.foreground.text.hover};
          box-shadow: inset 0 0 0 1px ${tertiary.surface.stroke.hover};

          ${StyledIcon} {
            color: ${tertiary.foreground.icon.hover};
          }
        }

        &:active {
          background-color: ${tertiary.surface.fill.pressed};
          color: ${tertiary.foreground.text.pressed};
          box-shadow: inset 0 0 0 1px ${tertiary.surface.stroke.pressed};

          ${StyledIcon} {
            color: ${tertiary.foreground.icon.pressed};
          }
        }
      `}

      ${as === 'button' &&
        !isLoading &&
        css `
        &:disabled {
          background-color: ${tertiary.surface.fill.disabled};
          color: ${tertiary.foreground.text.disabled};
          box-shadow: inset 0 0 0 1px ${tertiary.surface.stroke.disabled};

          ${StyledIcon} {
            color: ${tertiary.foreground.icon.disabled};
          }
        }
      `}
    `;
}}
`;
export const StyledButtonContent = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.size === 'xs' ? SYS_SPACE_FIXED_100 : SYS_SPACE_FIXED_150};

  ${(props) => props.isLoading &&
    css `
      opacity: 0;
      visibility: hidden;
      height: 0;
      pointer-events: none;
    `}
`;
export const StyledProgressIndicator = styled(ProgressIndicator) `
  position: absolute;
`;
//# sourceMappingURL=index.styles.js.map